import { forwardRef } from "react";
import Select from "react-select";

const SelectWrapper = forwardRef(
  (
    {
      data,
      defaultValue,
      value = "",
      onChange,
      onBlur,
      name,
      isError = false,
      disabled,
      isLoading = false,
    },
    ref
  ) => {
    const defaultValues = (options, value) => {
      return options ? options?.find((option) => option.value === value) : "";
    };    

    return (
      <Select
        ref={ref}
        isSearchable
        isDisabled={disabled}
        defaultValue={defaultValues(data, parseInt(defaultValue))}
        options={data}
        isLoading={isLoading}
        noOptionsMessage={() => "Not Found!"}
        placeholder={<div>Select an option</div>}
        isClearable
        value={defaultValues(data, value)}
        onBlur={onBlur}
        onChange={onChange}
        name={name}
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            borderColor: isError
              ? "#fa6684"
              : state.isFocused
              ? "#ccc"
              : "#ccc",
            boxShadow: state.isFocused ? 0 : 0,
            "&:hover": {
              borderColor: isError ? "#fa6684" : state.isFocused ? "#ccc" : 0,
            },
            height: 31, // set the height of the control
            minHeight: 31, // set the minimum height of the control
          }),
          valueContainer: (provided, state) => ({
            ...provided,
            height: 27, // set the height of the value container
            marginBottom: "2.5px",
            marginTop: "0px",
          }),
          singleValue: (provided, state) => ({
            ...provided,
            lineHeight: "18px", // set the line-height of the single value
          }),
          indicatorsContainer: (baseStyles) => ({
            ...baseStyles,
            "& div": {
              color: isError ? "#fa5c7c" : null,
              lineHeight: "16px",
              padding: "0px 5px",
              "&:hover": {
                color: isError ? "#fa5c7c" : null,
              },
            },
            "& span": {
              backgroundColor: isError && "#fa5c7c",
            },
          }),
        }}
      />
    );
  }
);

export default SelectWrapper;
